export default defineNuxtRouteMiddleware(to => {
  if (["/login", "/setup", "/reset-password"].includes(to.path)) return;
  if (!useUser().value) return navigateTo("/login");
});
